module.exports = __webpack_public_path__ + "static/background__printshop2-1c2acb2565a123fa43a280df8969264f.jpeg";